import { useLoaderData } from "react-router-dom";
import LandingPage from '../components/landing-page/LandingPage';
import MobileRegistrationForm from "../components/mobile-registration-form/MobileRegistrationForm";

export async function loader() {
  const response = await fetch('/api/countries');
  const { countries } = await response.json();
  return { countries };
}

export default function MobileRegistrationPage() {
  const { countries } = useLoaderData() as any;

  return (
    <LandingPage title={'Free Account Signup'}>
      <MobileRegistrationForm countries={countries} />
    </LandingPage>
  );
}